export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-14.png?a4a197bd095f9656bb5d3a3e34e9d2fb";